import { useContext } from 'react';
import { AddCertificatePanelContext } from './context';

export default function useOpenAddCertificatePanel() {
  const panel = useContext(AddCertificatePanelContext);
  if (!panel) throw new Error('useShowAddCertificatePanel must be used within an AddCertificatePanelProvider');

  return panel.open;
}
